import { Base64Url } from '#cmp/iabtcf/Base64Url.js';
const purposeOneBitIdx = 152;
const createdRange = { startBit: 6, lengthBits: 36 };
/** Extracts a specific bit range from the core part of an encoded TCString.
 * @param encodedTCString - The encoded TCString to decode.
 * @param bitStart - The starting bit index.
 * @param length - The number of bits to extract.
 * @returns The extracted bits as a string ('10010').
 * @throws if the encoded TCString is too short for the requested bit range or in invalid base64.
 */
export const decodeCorePart = (encodedTCString, bitStart, length) => {
    const [core] = encodedTCString.split('.');
    if (!core || core.length * 6 < bitStart + length) {
        throw new Error('Encoded TCString is too short for the requested bit range');
    }
    const startIndex = Math.floor(bitStart / 6);
    const endIndex = Math.ceil((bitStart + length) / 6);
    const decoded = Base64Url.decode(core.slice(startIndex, endIndex));
    const bitOffset = bitStart % 6;
    return decoded.slice(bitOffset, bitOffset + length);
};
export const decodePurposeOne = (encodedTCString) => {
    try {
        return decodeCorePart(encodedTCString, purposeOneBitIdx, 1) === '1';
    }
    catch {
        return false;
    }
};
/** Extracts the 'created' field from the encoded TCString.
 */
export const decodeCreated = (encodedTCString) => {
    try {
        const decoded = decodeCorePart(encodedTCString, createdRange.startBit, createdRange.lengthBits);
        const number = parseInt(decoded, 2);
        if (isNaN(number)) {
            return null;
        }
        const date = new Date(number * 100);
        return isNaN(date.getTime()) ? null : date;
    }
    catch {
        return null;
    }
};
